// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const exeggutor: PokeData = {
  "id": 103,
  "name": "exeggutor",
  "height": 20,
  "weight": 1200,
  "base_experience": 186,
  "types": [
    PokeType.GRASS,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "stomp",
    "absorb",
    "mega-drain",
    "leech-seed",
    "solar-beam",
    "stun-spore",
    "confusion",
    "hypnosis",
    "reflect",
    "egg-bomb",
    "barrage",
    "giga-drain",
    "synthesis",
    "uproar",
    "extrasensory",
    "bullet-seed",
    "worry-seed",
    "seed-bomb",
    "leaf-storm",
    "power-whip",
    "wood-hammer",
    "psyshock"
  ],
  "moves": [
    "solar-beam",
    "stun-spore",
    "reflect",
    "synthesis",
    "bullet-seed",
    "power-whip",
    "wood-hammer",
    "energy-ball",
    "psywave",
    "calm-mind",
    "psy-pulse",
    "synchronize",
    "psychic-fangs"
  ],
  "evolution_chain": {
    "id": 45,
    "item": null,
    "species": [
      {
        "name": "exeggcute",
        "order": 111,
        "types": [
          PokeType.GRASS,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "exeggutor",
        "order": 112,
        "types": [
          PokeType.GRASS,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 102,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "leaf-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 131,
    "speed": 82,
    "ability_power": 187
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
